import FooterLogo from './FooterLogo';

export default FooterLogo;
